function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import React from "react";
import styled from "styled-components";
import { context } from "../wr-context";
import { IoMdArrowBack } from "react-icons/io";
var BackButtonContainer = styled.div(_templateObject(), function(param) {
    var theme = param.theme;
    var ref;
    return (ref = theme.components.backButton) === null || ref === void 0 ? void 0 : ref.container;
});
var BackButton = function(param) {
    var onClick = param.onClick, to = param.to, label = param.label;
    return /*#__PURE__*/ React.createElement(BackButtonContainer, {
        onClick: function(ev) {
            if (onClick) {
                return onClick(ev);
            }
            if (to) {
                return context.history.push(to);
            }
            context.history.goBack();
        }
    }, /*#__PURE__*/ React.createElement(IoMdArrowBack, null), label || "Back");
};
export default BackButton;
